import React from 'react';

function fmtCurrency(v: number) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(v || 0);
}
function fmtPct(v: number) {
  return `${(v || 0).toFixed(1)}%`;
}

export default function SimpleBarChart({
  title,
  items,
  valueKey,
  labelKey,
  format,
}: {
  title: string;
  items: any[];
  valueKey: string;
  labelKey: string;
  format: 'currency' | 'percentage' | 'number';
}) {
  const max = Math.max(1, ...items.map((i) => Number(i[valueKey] || 0)));
  const formatVal = (v: number) => (format === 'currency' ? fmtCurrency(v) : format === 'percentage' ? fmtPct(v) : String(v));

  return (
    <div className="card">
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12 }}>
        <div style={{ fontWeight: 850 }}>{title}</div>
        <div className="muted" style={{ fontSize: 12 }}>
          {items.length} stages
        </div>
      </div>
      <div style={{ height: 10 }} />
      <div style={{ display: 'grid', gap: 8 }}>
        {items.map((i) => {
          const v = Number(i[valueKey] || 0);
          const pct = Math.max(0, Math.min(100, (v / max) * 100));
          return (
            <div key={String(i[labelKey])} style={{ display: 'grid', gridTemplateColumns: '160px 1fr 120px', gap: 10, alignItems: 'center' }}>
              <div className="muted">{String(i[labelKey])}</div>
              <div style={{ height: 10, borderRadius: 999, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)', overflow: 'hidden' }}>
                <div style={{ width: `${pct}%`, height: '100%', background: 'linear-gradient(90deg, rgba(124,58,237,0.9), rgba(37,99,235,0.9))' }} />
              </div>
              <div style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatVal(v)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
